import mixin from '../../mixins/Mixin.js';
import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';

const state = {
  all: [],
  selectedIds: [],
  selectedScreens: [],
  loading: false,
  currentPage: 1,
  nbPerPage: 8,
  endReached: false,
  // TO BE DELETED
  templateTitle: '',

  screens: [],
  currentScreen: '',
  defaultscreen: [],
  hasVideoIntro: {
    id: '',
    value: '',
  },
};

const mutations = {
  setListScreens(state, screens) {
    state.screens = screens;
    // for (var i = 0; i < screens.length; i++) {
    //   if (typeof screens[i].options == 'undefined') {
    //     screens[i].type = "Screen";
    //     screens[i].options = {duration: 5, transition: 'bounce', videointro: {html: '', css: '', duration: 7}};
    //   }
    // }
  },

  setScreens(state, data) {
    state.screens = data;
  },
  setSelectedScreenIds(state, data) {
    state.selectedIds = data;
  },
  setSelectedScreens(state, data) {
    state.selectedScreens = data;
  },
  pushScreens(state, screens) {
    state.all = state.all.concat(screens);
  },
  pushEdited(state, screens) {
    state.selectedScreens = state.selectedScreens.concat(screens);
  },
  duplicateScreens(state, screens) {
    state.selectedScreens = state.selectedScreens.concat(screens);
  },

  selectScreen(state, screenId) {
    if (state.selectedIds.includes(screenId)) {
      state.selectedIds = state.selectedIds.filter(s => s !== screenId);
    } else {
      state.selectedIds.push(screenId);
      state.all.forEach(function(item) {
        if (item.id === screenId) {
          item.options = { duration: 20000, videointro: { html: '', css: '', duration: 20000 } };
          item.transition = { in: '', out: '' };
          state.selectedScreens.push(item);
        }
      });

      // state.selectedScreens.push( state.all.find(item => item.id === screenId));
    }
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  incrementPage(state) {
    state.currentPage += 1;
  },

  setEndReached(state, endReached) {
    state.endReached = endReached;
  },

  // SET_LIST_SCREEN(state, screens) {
  //     state.screens = screens;
  //     for (var i = 0; i < screens.length; i++) {
  //         if (typeof screens[i].options == 'undefined') {
  //             screens[i].type = "Screen";
  //             screens[i].options = {duration: 5, transition: 'bounce', videointro: {html: '', css: '', duration: 7}};
  //         }
  //     }
  // },
  setComponentScreenByIndex(state, screen) {
    state.selectedScreens[screen.index].components = screen.components;
    state.selectedScreens[screen.index].html = screen.html;
    state.selectedScreens[screen.index].css = screen.css;
  },

  setTitleScreens(state, screens) {
    state.screens = screens;
    for (var i = 0; i < screens.length; i++) {
      screens[i].title = 'Screen ' + mixin.methods.makeId();
    }
  },

  setVideoIntro(state, obj) {
    if (!state.selectedScreens[obj.index].options) {
      state.selectedScreens[obj.index].options = {
        duration: 20,
        videointro: { html: '', css: '', duration: 0 },
      };
    }
    state.selectedScreens[obj.index].options.videointro.html = obj.intro;
    state.selectedScreens[obj.index].options.videointro.duration = obj.durationIntro;
    var videoIntro = {
      id: state.selectedScreens[obj.index].id,
      value: true,
    };
    state.hasVideoIntro = videoIntro;
  },

  setDurationScreen(state, data) {
    for (var i = 0; i < state.screens.length; i++) {
      if (state.screens[i].title == data.title) {
        state.screens[i].options.duration = data.duration;
      }
    }
  },
  setTransitionScreen(state, data) {
    state.selectedScreens = state.selectedScreens.map((screen, index) => {
      if (index === data.index - 1) {
        screen.transition.out = data.name + '-out';
      } else if (index === data.index) {
        screen.transition.in = data.name + '-in';
      }
      return screen;
    });
  },

  deleteScreensById(state, id) {
    state.selectedScreens = state.selectedScreens.filter(item => item.id !== id);
  },

  existanceScreen(state, title) {
    HTTP(window.ApiToken)
      .get(Routing.generate('api_screenDisplay_get_existant_screen'), {
        title: title,
      })
      .then(function(response) {
        return response.data.existance;
      });
  },

  setCurrentScreen(state, currentScreen) {
    state.currentScreen = currentScreen;
  },

  saveTitle(state, title) {
    state.templateTitle = title;
  },

  // pushScreen(state, screen) {
  //
  //
  //     screen.type = "Screen";
  //     screen.title = "Screen " +mixin.methods.makeId();
  //     screen.options = {
  //         duration: 2,
  //         transition: 'bounce',
  //         videointro: {html: '', css: '', duration: 10},
  //     };
  //     if (screen.screenShot === "") {
  //         screen.screenShot = "http://nbouaziz-web-dev.webtv-solution.com/version/FO/demo/display/screen.png";
  //     }
  //
  //     state.screens.push(screen);
  //
  //
  // },
  //
  // pushScreens(state, screens) {
  //     for (var i = 0; i < screens.length; i++) {
  //         var screen= screens[i];
  //         screen.type = "Screen";
  //         screen.title = "Screen " + mixin.methods.makeId();
  //         screen.options = {
  //             duration: 2,
  //             transition: 'bounce',
  //             videointro: {html: '', css: '', duration: 10},
  //         };
  //         if (screen.screenShot === "") {
  //             screen.screenShot = "http://nbouaziz-web-dev.webtv-solution.com/version/FO/demo/display/screen.png";
  //         }
  //
  //
  //         state.screens.push(screen);
  //
  //     }
  //
  // },

  concatScreen(state, screens) {
    state.screens.concat(screens);
  },

  updateScreenbyId(state, screenid) {
    state.screen = state.screens.filter(item => item.id === screenid.id);

    /* state.screen[0].components = screenid.component;
        state.screen[0].styles = screenid.style;
        state.screen[0].html = screenid.html;
        state.screen[0].assets = screenid.assets;
        state.screen[0].css = screenid.css;*/
  },

  updateScreenTitle(state, title) {
    var index = state.screens.findIndex(item => title.id === item.id);
    state.screens[index].title = title.newTitle;

    HTTP(window.ApiToken)
      .post(Routing.generate('api_screenDisplay_edit_title_disposition', { id: title.id }), {
        title: title.newTitle,
      })
      .then(function(response) {});
  },
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  async paginateScreens({ commit }) {
    /*commit('setLoading', true);
    const url = Routing.generate('api_screenDisplay_get_all_disposition', {
      page: state.currentPage,
      nbParPage: state.nbPerPage,
      type: 'Screen',
      client: localStorage.getItem('client')
    });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function (response) {
          resolve(response)
        });
    });

    commit('pushScreens', data.data.dispositions);

    commit('incrementPage');
    if (data.data.dispositions.length < state.nbPerPage) {
      commit('setEndReached', true);
    }
    commit('setLoading', false);*/
  },

  // paginateScreens: ({ state, commit }, screens) => commit('setScreens', screens),
  setScreens: ({ state, commit }, screens) => commit('setScreens', screens),
  setSelectedScreenIds: ({ state, commit }, screens) => commit('setSelectedScreenIds', screens),
  setSelectedScreens: ({ state, commit }, screens) => commit('setSelectedScreens', screens),
  selectScreen: ({ state, commit }, screenId) => commit('selectScreen', screenId),
  duplicateScreens: ({ state, commit }, screens) => commit('duplicateScreens', screens),

  setComponentScreenByIndex: ({ state, commit }, screen) =>
    commit('setComponentScreenByIndex', screen),
  setListScreens: ({ state, commit }, screens) => commit('setListScreens', screens),
  setTitleScreens: ({ state, commit }, screens) => commit('setTitleScreens', screens),
  setDurationScreen: ({ state, commit }, duration) => commit('setDurationScreen', duration),
  setTransitionScreen: ({ state, commit }, transition) => commit('setTransitionScreen', transition),
  setVideoIntro: ({ state, commit }, obj) => commit('setVideoIntro', obj),
  deleteScreensById: ({ state, commit }, id) => commit('deleteScreensById', id),
  concatScreen: ({ state, commit }, screens) => commit('concatScreen', screens),
  pushScreens: ({ state, commit }, screen) => commit('pushScreens', screen),
  pushEdited: ({ state, commit }, screen) => commit('pushEdited', screen),

  saveTitle: ({ state, commit }, title) => commit('saveTitle', title),
  setCurrentScreen: ({ state, commit }, currentScreen) => commit('setCurrentScreen', currentScreen),
  updateScreenbyId: ({ state, commit }, Screenid) => commit('updateScreenbyId', Screenid),
  updateScreenTitle: ({ state, commit }, title) => commit('updateScreenTitle', title),
};

// getters are functions
const getters = {
  getLoading: state => state.loading,
  getEndReached: state => state.endReached,
  getAll: state => state.all,
  getSelectedIds: state => state.selectedIds,
  getSelectedScreens: state => state.selectedScreens,
  getScreenPerId: state => id => {
    var screen = state.selectedScreens.find(item => item.id === id);
    return screen;
  },
  getHasVideoIntro: state => state.hasVideoIntro,
  getDefaultScreen: state => state.defaultscreen,
  getCurrentScreen: state => state.currentScreen,
  getTemplateTitle: state => state.templateTitle,
  // getCurrentscreename:  state => state.screens[state.currentScreen]['title'],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/screens-data.js